/* Macodesign — las pestañas de la ficha (Descripción / Detalles / Cuidados) pasan a
 * acordeón, las tres plegadas: el texto sólo aparece si la clienta lo abre.
 *
 * No se reescribe nada del tema: se reutilizan los mismos nodos que ya renderiza Liquid,
 * así que el contenido sigue saliendo de los metafields y la tipografía es la de siempre.
 * Si este archivo no llega a cargar, la ficha se queda con las pestañas de antes y no se
 * pierde nada.
 */
(function () {
  'use strict';
  if (window.__macoAcordeon) return;
  window.__macoAcordeon = true;

  var CSS = ''
    + '.ma-acc{border-top:1px solid #F0F0F0}'
    + '.ma-acc.ma-acc-fin{border-bottom:1px solid #F0F0F0}'
    /* Misma tipografía que tenían las pestañas: 13 px, peso 400, 0,1em, altas. */
    + '.ma-acc-t{display:flex;align-items:center;justify-content:space-between;gap:14px;'
    + 'width:100%;background:none;border:0;cursor:pointer;text-align:left;'
    + 'padding:15px 0;margin:0;font-family:inherit;font-size:13px;font-weight:400;'
    + 'letter-spacing:.1em;text-transform:uppercase;color:#787878;line-height:1.2;'
    + 'transition:color .18s ease}'
    + '.ma-acc-t[aria-expanded="true"]{color:#1A1515}'
    + '.ma-acc-t:hover{color:#1A1515}'
    + '.ma-acc-t:focus-visible{outline:1px solid #1A1515;outline-offset:3px}'
    /* Chevron dibujado con dos rayas: no depende de ningún icono del tema. */
    + '.ma-acc-i{flex:0 0 auto;width:11px;height:9px;position:relative;'
    + 'transition:transform .22s ease}'
    + '.ma-acc-t[aria-expanded="true"] .ma-acc-i{transform:rotate(180deg)}'
    + '.ma-acc-i:before,.ma-acc-i:after{content:"";position:absolute;top:4px;'
    + 'width:7px;height:1px;background:currentColor}'
    + '.ma-acc-i:before{left:0;transform:rotate(45deg)}'
    + '.ma-acc-i:after{right:0;transform:rotate(-45deg)}'
    /* El plegado va por max-height en píxeles, puesto desde JS. Se probó primero con
       grid-template-rows de 0fr a 1fr —más elegante sobre el papel— pero en la tienda la
       transición se quedaba pegada en el valor inicial y la caja no abría ni cerraba. */
    + '.ma-acc-c{overflow:hidden;max-height:0;transition:max-height .28s ease}'
    /* El tema pone los paneles inactivos en position:absolute con opacidad 0 —así hace la
       transición entre pestañas—. Dentro del acordeón todos vuelven al flujo normal; si no,
       no aportan alto y la caja queda en cero. */
    + '.tabs-wrapper .ma-acc .ma-acc-p{position:static;inset:auto;visibility:visible;'
    + 'opacity:1;min-height:0;display:block;padding:0 0 18px;margin:0;transition:none}'
    /* Las dos líneas de íconos (lavado y cambios) se mudan adentro de CUIDADOS. */
    + '.ma-acc .ma-acc-iconos{margin:0;padding:0 0 16px}'
    + '@media(prefers-reduced-motion:reduce){.ma-acc-c,.ma-acc-i{transition:none}}';

  function inyectarCSS() {
    if (document.getElementById('ma-acc-css')) return;
    var s = document.createElement('style');
    s.id = 'ma-acc-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function abrir(caja) {
    caja.setAttribute('data-abierto', '1');
    caja.style.maxHeight = caja.scrollHeight + 'px';
    // Al terminar la animación se suelta el tope, para que la caja siga al contenido si el
    // tema lo vuelve a pintar más largo.
    var fin = function (e) {
      if (e.propertyName !== 'max-height') return;
      caja.removeEventListener('transitionend', fin);
      if (caja.getAttribute('data-abierto')) caja.style.maxHeight = 'none';
    };
    caja.addEventListener('transitionend', fin);
  }

  function cerrar(caja) {
    caja.removeAttribute('data-abierto');
    // Hay que pasar por un valor concreto: de 'none' a 0 no hay nada que animar.
    caja.style.maxHeight = caja.scrollHeight + 'px';
    void caja.offsetHeight;
    caja.style.maxHeight = '0px';
  }

  function montar(raiz) {
    var cont = (raiz || document).querySelector('.tabs-wrapper .product-tabs');
    if (!cont || cont.getAttribute('data-ma-acc')) return false;

    var cabeza = cont.querySelector('.product-tabs__head, .tabs__head');
    var ul = cont.querySelector('ul.product-tabs-title, ul.tabs');
    var paneles = [].slice.call(cont.querySelectorAll('.tab-content'));
    if (!ul || !paneles.length) return false;

    var titulos = [].slice.call(ul.children);
    // Si el tema cambiara la estructura, mejor no tocar nada y dejar las pestañas.
    if (titulos.length !== paneles.length) return false;

    cont.setAttribute('data-ma-acc', '1');
    inyectarCSS();

    var frag = document.createDocumentFragment();
    var filas = [];

    titulos.forEach(function (li, i) {
      var panel = paneles[i];
      var texto = (li.textContent || '').trim();
      if (!texto) return;

      var fila = document.createElement('div');
      fila.className = 'ma-acc' + (i === titulos.length - 1 ? ' ma-acc-fin' : '');

      var boton = document.createElement('button');
      boton.type = 'button';
      boton.className = 'ma-acc-t';
      boton.id = 'ma-acc-t-' + i;
      boton.setAttribute('aria-controls', 'ma-acc-c-' + i);
      boton.setAttribute('aria-expanded', 'false');

      var rotulo = document.createElement('span');
      rotulo.textContent = texto;
      var icono = document.createElement('span');
      icono.className = 'ma-acc-i';
      icono.setAttribute('aria-hidden', 'true');
      boton.appendChild(rotulo);
      boton.appendChild(icono);

      var caja = document.createElement('div');
      caja.className = 'ma-acc-c';
      caja.id = 'ma-acc-c-' + i;
      caja.setAttribute('role', 'region');
      caja.setAttribute('aria-labelledby', boton.id);

      // El tema esconde los paneles que no son la pestaña activa; acá se les pone la misma
      // clase que usa para el panel visible, así heredan su estado normal en vez de tener
      // que pelear contra sus reglas.
      panel.classList.add('current');
      panel.classList.add('ma-acc-p');
      caja.appendChild(panel);

      boton.addEventListener('click', function () {
        var abierto = boton.getAttribute('aria-expanded') === 'true';
        boton.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        if (abierto) cerrar(caja); else abrir(caja);
      });

      fila.appendChild(boton);
      fila.appendChild(caja);
      frag.appendChild(fila);
      filas.push({ texto: texto, caja: caja });
    });

    if (cabeza) cabeza.style.display = 'none';
    cont.appendChild(frag);
    moverIconos(cont, filas);
    return true;
  }

  /**
   * "Lavar a mano con agua fría" y "Producto con 30 días de cambio" son un bloque aparte
   * del tema, justo debajo de las pestañas. Sueltos ahí quedaban colgando bajo un acordeón
   * cerrado, así que se mudan adentro de CUIDADOS.
   */
  function moverIconos(cont, filas) {
    if (!filas.length) return;
    var caja = cont.closest ? cont.closest('.tabs-wrapper') : null;
    var iconos = caja && caja.nextElementSibling;
    if (!iconos || !/block__icon__row/.test((iconos.className || '').toString())) return;

    var destino = null;
    for (var i = 0; i < filas.length; i++) {
      if (/cuidado/i.test(filas[i].texto)) { destino = filas[i].caja; break; }
    }
    if (!destino) destino = filas[filas.length - 1].caja;

    iconos.classList.add('ma-acc-iconos');
    destino.appendChild(iconos);
  }

  function intentar() { try { montar(document); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', intentar);
  } else {
    intentar();
  }

  // El tema vuelve a pintar la ficha al cambiar de variante o desde el editor: si aparecen
  // pestañas nuevas sin marcar, se convierten también.
  document.addEventListener('shopify:section:load', intentar);
  if (window.MutationObserver) {
    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () { pendiente = false; intentar(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
